/** A booking-engine banner belongs to the page that raised it; query-only writes (selection, dates) stay on the page and keep it. */
export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path !== from.path) useBookingEngineErrorNotification().clear();
});
